import type { Maybe } from "@/graphql/generated-types";
import type { IMultiSelectItem } from "@/interfaces";
import type { EntityWithId } from "@/types";
import type { Ref } from "vue";

const toSelectableIds = (
  listItems: Ref<IMultiSelectItem[]>,
  entities?: Maybe<EntityWithId[]>,
) => {
  const ids = (entities || []).map((item) => item.id);
  return ids.filter((id) =>
    listItems.value.map((option) => option.id).includes(id),
  );
};

const toList = (list: Ref<IMultiSelectItem[]>, ids?: Maybe<string[]>) => {
  return (ids || [])
    .map((id) => {
      return list.value.find((item) => item.id === id);
    })
    .filter((item) => !!item);
};

export default {
  toSelectableIds,
  toList,
};
